module.exports = __webpack_public_path__ + "static/media/water_detected.ee38b5a6.svg";